import { type Memberships } from './collections/memberships'

export const employeeMemberships = (memberships: Memberships, employeeId: string) => {
  return memberships.filter({
    employee_id: employeeId,
  })
}
